<template>
  <div class="cta-banner">
    <p>
      Hire a Bartender Who Knows The Best Cocktail Drinks!
      <a
        href="https://bartendlongisland.com/bartender-booking/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Book a Bartender Now
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'CTABanner',
};
</script>

<style scoped>
.cta-banner {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #d39a84; /* Warm call-to-action color for visibility */
  color: #ffffff; /* White text for readability */
  text-align: center;
  padding: 15px;
  z-index: 1000;
  font-size: 1rem;
  font-family: 'Arial', sans-serif;
}

.cta-banner a {
  color: #333333; /* Dark text for links to contrast with the background */
  font-weight: bold;
  text-decoration: none;
}

.cta-banner a:hover {
  color: #f9f6f5; /* Light text color on hover for visibility */
  text-decoration: underline;
}
</style>
